import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  constructor() { }
  static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
    
    let config = 
    {
      'required': 'This field is required !',
      'invalidEmailAddress': '* Invalid email address',
      'invalidCityName': '* Invalid city name',
      'invalidStreetAddress': '* Invalid street address',
      'invalidPhoneNumber': '* Invalid phone number',
      'invalidPassword': '* Password must be at least 8 characters long.',
    };

    return config[validatorName];
  }



  static emailValidator(control) {
    // RFC 2822 compliant regex
    if(control.value)
    {
      if (control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
        return null;
      } else {
        return { 'invalidEmailAddress': true };
      }
    }
    
  }

  static passwordValidator(control) {
    // {6,100}           - Assert password is between 6 and 100 characters
    // (?=.*[0-9])       - Assert a string has at least one number
    if(control.value)
    {
      if (control.value.match(/^[a-zA-Z0-9!@#$%^&*]{6,100}$/)) {
        return null;
      } else {
        return { 'invalidPassword': true };
      }
    }
   
  }
  static phoneNumberValidator(control) {

    if(control.value)
    {
      if (control.value.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im)) {
        return null;
      } else {
        return { 'invalidPhoneNumber': true };
      }
    }
   
  }

  static commonValidator(control) {
  //  return control.value && null ||  {'invalidPassword': true };
    if(control.value)
    {
      return null;
    }
    else 
    {
      return {'invalidCityName': true };
    }
   
  }
}
